'use-strict';

module.exports = ['$scope', '$rootScope', '$stateParams', 'ngDroUtilsNotify', 'CanDoServices', 'ngDroUAA', '$templateCache', '$transitions', '$state',
    function ($scope, $rootScope, $stateParams, ngDroUtilsNotify, CanDoServices, ngDroUAA, $templateCache, $transitions, $state) {

        /*
         * Config
         */
        $templateCache.put('company-form.html', require('./tabs/company-form.html'));
        $templateCache.put('company-kiosk.html', require('./tabs/company-kiosk.html'));
        $templateCache.put('company-person.html', require('./tabs/company-person.html'));


        // Informazioni per la parametrizzazione della direttiva navabar-title.
        //$scope.infoTitle = {icon: 'fa-sitemap fa-fw', message: 'jdro_company.modal.title'};


        /*
         * Init
         */

        // Ottengo i permessi per le operazioni Update o Create
        var _perms = $stateParams.id ? ["UPDATE"] : ["CREATE"];
        CanDoServices.canDo("COMPANY_DISTRICT", _perms).then(function (perms) {
            $scope.jdroPerms = perms;
        });

        $scope.company = {}; // Sarà visibile anche in CompanyFormController (controller annidato)
        $scope.backupCompany = {};  // Controllo se l'utente modifica qualche campo con JSON.stringfy 

        /**
         * A seconda se $stateParams.id esista o meno, capisco se è una edit o add         
         * NB: l'id del padre deve essere sempre passato dentro company
         */
        if ($stateParams.id) {

            ngDroUAA.Company.findOne($stateParams.id).then(function (response) { // scarico il distretto
                $scope.company = response.data;

                if ($scope.company.parent !== 0) {
                    ngDroUAA.Company.findOne($scope.company.parent).then(function (response) {
                        var father = response.data;
                        $scope.company.parent = father.id;
                        $scope.father = father.name;
                        angular.copy($scope.company, $scope.backupCompany);
                    });
                } else { // root
                    $scope.father = null;
                    angular.copy($scope.company, $scope.backupCompany);
                }
            });
        } else {
            // devi avere le informazioni del padre, ovvero dove ha cliccato altrimenti lo rimandi indietro
            if (!$rootScope.company_father) {
                $state.go('uaa-module-company');
            }

            $scope.father = $rootScope.company_father.name;

            // devo settare l'id del padre e il nodePath
            $scope.company.parent = $rootScope.company_father.id;
            $scope.company.nodePath = $rootScope.company_father.id + "/";
            $scope.company.nodePath = $rootScope.company_father.nodePath + $scope.company.nodePath;

            delete $rootScope.company_father;

            angular.copy($scope.company, $scope.backupCompany);
        }




        /* Setto un listener su location change :
         *      se ho cambiato qualche campo e non ho salvato faccio uscire un modal di conferma.
         */
        $scope.deregisterListener = $transitions.onStart({to: '*'}, catchStateTransition);
        ngDroUtilsNotify.setDeregisterListner( $scope.deregisterListener );
        /*
         * Methods
         */

        function catchStateTransition(transition) {
            if (JSON.stringify($scope.company) !== JSON.stringify($scope.backupCompany)) {

                var options = {
                    form: $scope.companyForm,
                    next: transition.to().name,
                    name: $scope.company.name,
                    success: $scope.submit,
                    dismiss: $scope.redirect,
                    perms: $scope.hasPerms
                };

                ngDroUtilsNotify.confirmUnsavedChanges(options);

                return false; // equivale al vecchio event.preventDefault();
            }
        }

        // mi serve nel template per disabilitare i campi 
        $scope.hasPerms = function () {
            return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
        };

        // Questa funzione viene invocata sull'ng-show del Company controller.
        $scope.existCompany = function () {
            if ($scope.company.id)
                return true;
            else
                return false;
        };

        // Chiusura della finestra.
        $scope.cancel = function () {
            $state.go('uaa-module-company-list');
        };

        // Redirect alla pagina della lista.         
        $scope.redirect = function (next) {
            ngDroUtilsNotify.unregisterListner();
            next = next ? next : 'uaa-module-company-list';
            $state.go(next);
        };

    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/company/companyDetail/companyDetailCtrl.js
// module id = 422
// module chunks = 0